<template>
  <div
    id="tabel-dinamis-visualization-table-metadata"
    class="mt-4"
    style="scroll-margin-top: 70px"
  >
    <b-card class="my-4" no-body v-if="subjectMetadata">
      <b-card-header
        header-class="td-bg-light-blue td-text-blue td-border-blue td-border-solid td-border-thin"
      >
        <h5 class="m-0">Metadata Subjek Statistik</h5>
      </b-card-header>

      <b-card-body body-class="td-border-blue td-border-solid td-border-thin">
        <b-row class="mt-2">
          <b-col>
            <b-icon icon="bookmarks-fill" />
            <span class="font-weight-bold ml-1">Subjek Statistik</span>
          </b-col>
        </b-row>

        <b-row>
          <b-col class="ml-4" cols="10">
            <span class="font-weight-bolder" style="font-size: 0.75rem"
              >{{ changeNullIntoStrip(subjectMetadata.name) }}
            </span>
          </b-col>
        </b-row>

        <b-row class="mt-2">
          <b-col>
            <b-icon icon="chat-right-quote-fill" />
            <span class="font-weight-bold ml-1">Deskripsi</span>
          </b-col>
        </b-row>

        <b-row>
          <b-col class="ml-4" cols="10">
            <span style="font-size: 0.75rem"
              >{{ changeNullIntoStrip(subjectMetadata.description) }}
            </span>
          </b-col>
        </b-row>

        <b-row class="mt-2">
          <b-col>
            <b-icon icon="globe" />
            <span class="font-weight-bold ml-1">Referensi</span>
          </b-col>
        </b-row>

        <b-row>
          <b-col class="ml-4" cols="10">
            <template
              v-if="
                subjectMetadata.reference != null &&
                isUrl(subjectMetadata.reference)
              "
            >
              <b-link
                :href="subjectMetadata.reference"
                target="_blank"
                style="font-size: 0.75rem"
                >{{ subjectMetadata.reference }}
              </b-link>
            </template>

            <template v-else>
              <span style="font-size: 0.75rem">
                {{ changeNullIntoStrip(subjectMetadata.reference) }}
              </span>
            </template>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>

    <b-card class="my-4" no-body>
      <b-card-header
        class="td-bg-light-teal td-text-teal td-border-teal td-border-solid td-border-thin"
      >
        <h5 class="m-0">Metadata Dataset</h5>
      </b-card-header>

      <b-card-body body-class="td-border-teal td-border-solid td-border-thin">
        <b-row class="mt-2">
          <b-col>
            <b-icon icon="bookmarks-fill" />
            <span class="font-weight-bold ml-1">Dataset</span>
          </b-col>
        </b-row>

        <b-row>
          <b-col class="ml-4" cols="10">
            <span class="font-weight-bolder" style="font-size: 0.75rem"
              >{{ changeNullIntoStrip(datasetMetadata.name) }}
            </span>
          </b-col>
        </b-row>

        <b-row class="mt-2">
          <b-col>
            <b-icon icon="calendar2-week" />
            <span class="font-weight-bold ml-1">Frekuensi</span>
          </b-col>
        </b-row>

        <b-row>
          <b-col class="ml-4" cols="10">
            <span style="font-size: 0.75rem"
              >{{ changeNullIntoStrip(datasetMetadata.frequency) }}
            </span>
          </b-col>
        </b-row>

        <b-row class="mt-2">
          <b-col>
            <b-icon icon="puzzle-fill" />
            <span class="font-weight-bold ml-1">Jenis Data</span>
          </b-col>
        </b-row>

        <b-row>
          <b-col class="ml-4" cols="10">
            <span style="font-size: 0.75rem"
              >{{ changeNullIntoStrip(datasetMetadata.dataType) }}
            </span>
          </b-col>
        </b-row>

        <b-row class="mt-2">
          <b-col>
            <b-icon icon="building" />
            <span class="font-weight-bold ml-1">Pemilik Data</span>
          </b-col>
        </b-row>

        <b-row>
          <b-col class="ml-4" cols="10">
            <span style="font-size: 0.75rem"
              >{{ changeNullIntoStrip(datasetMetadata.owner) }}
            </span>
          </b-col>
        </b-row>

        <b-row class="mt-2">
          <b-col>
            <b-icon icon="people-fill" />
            <span class="font-weight-bold ml-1">Divisi Pengelola Data</span>
          </b-col>
        </b-row>

        <b-row>
          <b-col class="ml-4" cols="10">
            <span style="font-size: 0.75rem"
              >{{ changeNullIntoStrip(datasetMetadata.maintainer) }}
            </span>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>

    <b-card class="my-4" no-body>
      <b-card-header
        class="td-bg-light-orange td-text-orange td-border-orange td-border-solid td-border-thin"
      >
        <h5 class="m-0">Metadata Indikator</h5>
      </b-card-header>

      <b-card-body
        v-if="indicatorMetadata[selectedIndicator] != null"
        body-class="td-border-orange td-border-solid td-border-thin"
      >
        <b-row class="text-right">
          <b-col>
            <b-button
              :class="
                (selectedIndicator === idx
                  ? 'td-btn-orange'
                  : 'td-btn-outline-orange') + ' mr-1'
              "
              v-for="(item, idx) in indicatorMetadata"
              :key="idx"
              size="sm"
              pill
              @click="selectedIndicator = idx"
            >
              {{ item.name }}
            </b-button>
          </b-col>
        </b-row>

        <div
          class="metadata-indicator-container"
          v-for="(item, idx) in indicatorMetadata"
          :key="idx"
          v-show="selectedIndicator === idx"
        >
          <b-row class="mt-2">
            <b-col>
              <b-icon icon="bookmarks-fill" />
              <span class="font-weight-bold ml-1">Indikator</span>
            </b-col>
          </b-row>

          <b-row>
            <b-col class="ml-4" cols="10">
              <span class="font-weight-bolder" style="font-size: 0.75rem">
                {{ changeNullIntoStrip(item.name) }}
              </span>
            </b-col>
          </b-row>

          <b-row class="mt-2">
            <b-col>
              <b-icon icon="chat-right-quote-fill" />
              <span class="font-weight-bold ml-1">Definisi</span>
            </b-col>
          </b-row>

          <b-row>
            <b-col class="ml-4" cols="10">
              <span style="font-size: 0.75rem">
                {{ changeNullIntoStrip(item.definition) }}
              </span>
            </b-col>
          </b-row>

          <b-row class="mt-2">
            <b-col>
              <b-icon icon="gear-wide-connected" />
              <span class="font-weight-bold ml-1">Mekanisme Perhitungan</span>
            </b-col>
          </b-row>

          <b-row>
            <b-col class="ml-4" cols="10">
              <span style="font-size: 0.75rem">
                {{ changeNullIntoStrip(item.calculationMechanism) }}
              </span>
            </b-col>
          </b-row>

          <b-row class="mt-2">
            <b-col>
              <b-icon icon="calculator-fill" />
              <span class="font-weight-bold ml-1">Rumus</span>
            </b-col>
          </b-row>

          <b-row>
            <b-col class="ml-4" cols="10">
              <span
                v-if="changeNullIntoStrip(item.formula) === '-'"
                style="font-size: 0.75rem"
              >
                {{ changeNullIntoStrip(item.formula) }}
              </span>
              <katex-element
                v-else
                output="html"
                :displayMode="true"
                :expression="item.formula"
              />
            </b-col>
          </b-row>

          <b-row class="mt-2">
            <b-col>
              <b-icon icon="shield-check" />
              <span class="font-weight-bold ml-1">Manfaat</span>
            </b-col>
          </b-row>

          <b-row>
            <b-col class="ml-4" cols="10">
              <span style="font-size: 0.75rem"
                >{{ changeNullIntoStrip(item.benefit) }}
              </span>
            </b-col>
          </b-row>

          <b-row class="mt-2">
            <b-col>
              <b-icon icon="layers-half" />
              <span class="font-weight-bold ml-1">Interpretasi</span>
            </b-col>
          </b-row>

          <b-row>
            <b-col class="ml-4" cols="10">
              <span style="font-size: 0.75rem">
                {{ changeNullIntoStrip(item.interpretation) }}
              </span>
            </b-col>
          </b-row>

          <b-row class="mt-2">
            <b-col>
              <b-icon icon="info-circle" />
              <span class="font-weight-bold ml-1">Satuan</span>
            </b-col>
          </b-row>

          <b-row>
            <b-col class="ml-4" cols="10">
              <span style="font-size: 0.75rem">
                {{ changeNullIntoStrip(item.measurementUnit) }}
              </span>
            </b-col>
          </b-row>

          <b-row class="mt-2">
            <b-col>
              <b-icon icon="puzzle-fill" />
              <span class="font-weight-bold ml-1">Disaggregasi</span>
            </b-col>
          </b-row>

          <b-row>
            <b-col class="ml-4" cols="10">
              <span style="font-size: 0.75rem">
                {{ changeNullIntoStrip(item.disaggregation) }}
              </span>
            </b-col>
          </b-row>

          <b-row class="mt-2">
            <b-col>
              <b-icon icon="question-circle" />
              <span class="font-weight-bold ml-1">Indikator Standar</span>
            </b-col>
          </b-row>

          <b-row>
            <b-col class="ml-4" cols="10">
              <span style="font-size: 0.75rem">
                {{ changeNullIntoStrip(item.standard) }}
              </span>
            </b-col>
          </b-row>

          <b-row class="mt-2">
            <b-col>
              <b-icon icon="calendar2-week" />
              <span class="font-weight-bold ml-1">Frekuensi Update</span>
            </b-col>
          </b-row>

          <b-row>
            <b-col class="ml-4" cols="10">
              <span style="font-size: 0.75rem">
                {{ changeNullIntoStrip(item.updateFrequency) }}
              </span>
            </b-col>
          </b-row>

          <b-row class="mt-2">
            <b-col>
              <b-icon icon="map-fill" />
              <span class="font-weight-bold ml-1">Level Penyajian</span>
            </b-col>
          </b-row>

          <b-row>
            <b-col class="ml-4" cols="10">
              <span style="font-size: 0.75rem">
                {{ changeNullIntoStrip(item.presentationLevel) }}
              </span>
            </b-col>
          </b-row>

          <b-row class="mt-2">
            <b-col>
              <b-icon icon="building" />
              <span class="font-weight-bold ml-1"
                >Organisasi Penanggung Jawab</span
              >
            </b-col>
          </b-row>

          <b-row>
            <b-col class="ml-4" cols="10">
              <span style="font-size: 0.75rem">
                {{ changeNullIntoStrip(item.responsibleOrganization) }}
              </span>
            </b-col>
          </b-row>

          <b-row class="mt-2">
            <b-col>
              <b-icon icon="dice5-fill" />
              <span class="font-weight-bold ml-1">Ukuran</span>
            </b-col>
          </b-row>

          <b-row>
            <b-col class="ml-4" cols="10">
              <span style="font-size: 0.75rem">
                {{ changeNullIntoStrip(item.measurement) }}
              </span>
            </b-col>
          </b-row>

          <b-row class="mt-2">
            <b-col>
              <b-icon icon="box" />
              <span class="font-weight-bold ml-1">Konsep</span>
            </b-col>
          </b-row>

          <ul style="list-style-type: circle">
            <li v-for="(concept, idx) in item.conceptList" :key="idx">
              {{ concept.concept }}
            </li>
          </ul>
        </div>
      </b-card-body>
    </b-card>

    <b-card class="my-4" no-body>
      <b-card-header
        class="td-bg-light-green td-text-green td-border-green td-border-solid td-border-thin"
      >
        <h5 class="m-0">Metadata Dimensi</h5>
      </b-card-header>

      <b-card-body
        v-if="dimensionMetadata[selectedDimension] != null"
        body-class="td-border-green td-border-solid td-border-thin"
      >
        <b-row class="text-right">
          <b-col>
            <b-button
              :class="
                (selectedDimension === idx
                  ? 'td-btn-green'
                  : 'td-btn-outline-green') + ' mr-1'
              "
              v-for="(item, idx) in dimensionMetadata"
              :key="idx"
              size="sm"
              pill
              @click="selectedDimension = idx"
            >
              {{ item.name }}
            </b-button>
          </b-col>
        </b-row>

        <div
          class="metadata-dimension-container"
          v-for="(item, idx) in dimensionMetadata"
          :key="idx"
          v-show="selectedDimension === idx"
        >
          <b-row class="mt-2">
            <b-col>
              <b-icon icon="bookmarks-fill" />
              <span class="font-weight-bold ml-1">Dimensi</span>
            </b-col>
          </b-row>

          <b-row>
            <b-col class="ml-4" cols="10">
              <span class="font-weight-bolder" style="font-size: 0.75rem">
                {{ capitalizeEachWord(item.name) }}
              </span>
            </b-col>
          </b-row>

          <b-row class="mt-2">
            <b-col>
              <b-icon icon="info-circle" />
              <span class="font-weight-bold ml-1">Versi Klasifikasi</span>
            </b-col>
          </b-row>

          <b-row>
            <b-col class="ml-4" cols="10">
              <span style="font-size: 0.75rem"
                >{{ item.classificationVersion }}
              </span>
            </b-col>
          </b-row>

          <b-row class="mt-2">
            <b-col>
              <b-icon icon="box" />
              <span class="font-weight-bold ml-1">Domain Nilai</span>
            </b-col>
          </b-row>

          <b-row>
            <b-col class="ml-4" cols="10">
              <span style="font-size: 0.75rem"
                >{{ changeNullIntoStrip(item.dimensionValueDomainName) }}
              </span>
            </b-col>
          </b-row>

          <b-row class="mt-2">
            <b-col>
              <b-icon icon="caret-down" />
              <span class="font-weight-bold ml-1">Level Item Teratas</span>
            </b-col>
          </b-row>

          <b-row>
            <b-col class="ml-4" cols="10">
              <span style="font-size: 0.75rem"
                >{{ changeNullIntoStrip(item.initialParentLevel) }}
              </span>
            </b-col>
          </b-row>

          <b-row class="mt-2">
            <b-col>
              <b-icon icon="caret-up" />
              <span class="font-weight-bold ml-1">Level Item Terbawah</span>
            </b-col>
          </b-row>

          <b-row>
            <b-col class="ml-4" cols="10">
              <span style="font-size: 0.75rem"
                >{{ changeNullIntoStrip(item.lowestLevel) }}
              </span>
            </b-col>
          </b-row>

          <b-row class="mt-2">
            <b-col>
              <b-icon icon="list-task" />
              <span class="font-weight-bold ml-1">Daftar Item Dimensi</span>
            </b-col>
          </b-row>

          <b-row>
            <b-col class="ml-4" cols="8">
              <b-table-simple class="mt-2" hover responsive small striped>
                <b-thead class="td-bg-green text-light">
                  <b-tr>
                    <b-th> Kode </b-th>
                    <b-th> Nama </b-th>
                    <b-th> Deskripsi </b-th>
                  </b-tr>
                </b-thead>
                <b-tbody>
                  <template
                    v-if="
                      dimensionMetadata[
                        selectedDimension
                      ].role.toLowerCase() === 'region' &&
                      optionsRegionUnited !== ''
                    "
                  >
                    <b-tr
                      v-for="(
                        itemDimension, idx_itemDimension
                      ) of optionsRegionUnited"
                      :key="idx_itemDimension"
                    >
                      <b-td align="center">
                        {{ itemDimension.code }}
                      </b-td>
                      <b-td>
                        {{ itemDimension.name }}
                        <template
                          v-if="
                            itemDimension.code.length === 4 &&
                            itemDimension.code.substring(2, 3) === '7'
                          "
                        >
                          (Kota)
                        </template>
                      </b-td>
                      <b-td>
                        {{ changeNullIntoStrip(itemDimension.description) }}
                      </b-td>
                    </b-tr>
                  </template>

                  <template
                    v-else-if="
                      dimensionMetadata[
                        selectedDimension
                      ].role.toLowerCase() === 'dimension'
                    "
                  >
                    <b-tr
                      v-for="(
                        itemDimension, idx_itemDimension
                      ) of item.selectedItemDimension"
                      :key="idx_itemDimension"
                    >
                      <b-td align="center">
                        {{ itemDimension.code }}
                      </b-td>
                      <b-td>
                        {{ itemDimension.name }}
                      </b-td>
                      <b-td>
                        {{ changeNullIntoStrip(itemDimension.description) }}
                      </b-td>
                    </b-tr>
                  </template>
                </b-tbody>
                <b-tfoot>
                  <b-tr>
                    <b-td colspan="3" variant="" class="text-right">
                      Jumlah Item:
                      <template
                        v-if="
                          dimensionMetadata[
                            selectedDimension
                          ].role.toLowerCase() === 'region'
                        "
                      >
                        <span class="font-weight-bold">
                          {{ optionsRegionUnited.length }}
                        </span>
                      </template>

                      <template
                        v-else-if="
                          dimensionMetadata[
                            selectedDimension
                          ].role.toLowerCase() === 'dimension'
                        "
                      >
                        <span class="font-weight-bold">
                          {{ item.selectedItemDimension.length }}
                        </span>
                      </template>
                    </b-td>
                  </b-tr>
                </b-tfoot>
              </b-table-simple>
            </b-col>
          </b-row>
        </div>
      </b-card-body>
    </b-card>
  </div>
</template>

<!-- javascript section-->
<script>
//import js modules section
import isUrl from "validator/lib/isURL";
import utils from "../../../../../../../utils/TabelDinamisUtils.js";

//local registration for output component
export default {
  name: "VisualizationTableMetadata",
  data() {
    return {
      selectedIndicator: 0,
      selectedDimension: 0,
    };
  },
  props: ["selectedDataList", "choosenDataIdx"],
  created() {},
  destroyed() {},
  mounted() {},
  computed: {
    subjectMetadata() {
      return this.choosenDataIdx == null || this.choosenDataIdx < 0
        ? ""
        : this.selectedDataList[this.choosenDataIdx].selectedSubject;
    },
    datasetMetadata() {
      return this.choosenDataIdx == null || this.choosenDataIdx < 0
        ? ""
        : this.selectedDataList[this.choosenDataIdx].selectedDataset;
    },
    indicatorMetadata() {
      return this.choosenDataIdx == null || this.choosenDataIdx < 0
        ? ""
        : this.selectedDataList[this.choosenDataIdx].selectedIndicator;
    },
    dimensionMetadata() {
      return this.choosenDataIdx == null || this.choosenDataIdx < 0
        ? ""
        : this.selectedDataList[this.choosenDataIdx].selectedDimension;
    },
    regionDimensionIdx() {
      if (this.dimensionMetadata === "") {
        return null;
      } else {
        return this.dimensionMetadata.findIndex(
          (item) => item.role.toLowerCase() === "region"
        );
      }
    },
    optionsRegionDimension() {
      if (this.regionDimensionIdx == null) {
        return "";
      } else {
        return this.dimensionMetadata[this.regionDimensionIdx];
      }
    },
    optionsRegionUnited() {
      switch (this.optionsRegionDimension.selectedRegionLevel) {
        case "NationalByProvince":
        case "ProvinceByDistrict":
          return this.optionsRegionDimension.selectedItemDimension;

        case "DistrictBySubdistrict":
          if (this.optionsRegionDimension.selectedProvince === "") {
            return this.optionsRegionDimension.selectedItemDimension;
          } else {
            let temp = [];
            temp.push(this.optionsRegionDimension.selectedProvince);
            return temp.concat(
              this.optionsRegionDimension.selectedItemDimension
            );
          }

        case "SubdistrictByVillage":
          if (
            this.optionsRegionDimension.selectedProvince === "" &&
            this.optionsRegionDimension.selectedDistrict === ""
          ) {
            return this.optionsRegionDimension.selectedItemDimension;
          } else if (
            this.optionsRegionDimension.selectedProvince === "" &&
            this.optionsRegionDimension.selectedDistrict !== ""
          ) {
            let temp = [];
            temp.push(this.optionsRegionDimension.selectedDistrict);
            return temp.concat(
              this.optionsRegionDimension.selectedItemDimension
            );
          } else if (
            this.optionsRegionDimension.selectedProvince !== "" &&
            this.optionsRegionDimension.selectedDistrict !== ""
          ) {
            let temp = [];
            temp.push(this.optionsRegionDimension.selectedProvince);
            temp.push(this.optionsRegionDimension.selectedDistrict);
            return temp.concat(
              this.optionsRegionDimension.selectedItemDimension
            );
          } else {
            return null;
          }
        default:
          return null;
      }
    },
  },
  watch: {
    choosenDataIdx: {
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.selectedIndicator = 0;
          this.selectedDimension = 0;
        }
      },
      immediate: true,
    },
  },
  methods: {
    isUrl(val) {
      return isUrl(val);
    },
    changeNullIntoStrip(val) {
      return utils.changeNullIntoStrip(val);
    },
    capitalizeEachWord(str) {
      return utils.capitalizeEachWord(str);
    },
  },
  components: {},
};
</script>

<!-- css section-->
<style lang="scss" scoped>
@import "src/assets/scss/_table-dinamis";
</style>

<!-- author: m.	nif.fahyuananto-->
<!-- version 3.0.0 -->
<!-- created on 31-10-2022 -->
